import React, { useState } from "react";

import CreatableSelect from "react-select/creatable";
import { setLoading } from "../../../redux/reducers/ColumnConfig";

import { Formik, Form, Field, FieldProps } from "formik";
import Select from "react-select";
import styled from "@emotion/styled";
import { FormGroup } from "react-bootstrap";

interface Option {
  readonly label: string;
  readonly value: string;
}

type Props = {
  type: "customer" | "vendor";
  createFn: (newValue: string) => Promise<{ name: string; id: string }>;
  defaultOptions: Option[];
  onChange: (option: any) => any;
};

export const QboSelect: React.FC<Props> = ({
  createFn,
  defaultOptions,
  onChange,
  type,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [value, setValue] = useState<Option | null>();

  const handleCreate = (inputValue: string) => {
    setIsLoading(true);

    createFn(inputValue)
      .then((rsp) => {
        const newOption = { label: rsp.name, value: rsp.id };
        setIsLoading(false);
        setOptions((prev) => [...prev, newOption]);
        setValue(newOption);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  return (
    <CreatableSelect
      placeholder="Type to create a new item"
      {...rest}
      isClearable
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={(newValue) => {
        setValue(newValue);
        onChange(newValue);
      }}
      onCreateOption={handleCreate}
      options={options}
      value={value}
      formatCreateLabel={(val) => `Create ${type} "${val}"`}
    />
  );
};

const ErrorMessage = styled.div`
  color: var(--watermelon);
`;

export const FormikQboSelect = ({
  createFn,
  type,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}: FieldProps & {
  label: string;
  options: Array<{ value: string; label: string }>;
  createFn: any;
  type: "customer" | "vendor";
}) => {
  const { options } = props;

  return (
    <FormGroup>
      <label htmlFor={field.name}>{props.label}</label>
      <QboSelect
        {...field}
        {...props}
        defaultOptions={options}
        // value={
        //   (options
        //     ? options.find((option) => option.value === field.value)
        //     : "") as any
        // }
        onChange={(option) => setFieldValue(field.name, (option as any).value)}
        createFn={createFn}
        type={type}
      />
      {touched[field.name] && errors[field.name] && (
        <ErrorMessage>{errors[field.name]}</ErrorMessage>
      )}
    </FormGroup>
  );
};
